var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iosBtn",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"iosBtn_package",class:{iosBtn_on:_vm.module}},[_c('div',{staticClass:"iosBtn_inner"}),_c('div',{staticClass:"iosBtn_background"})])])}
var staticRenderFns = []

export { render, staticRenderFns }